import React from 'react';
import { twMerge } from 'tailwind-merge';

import { IMenu } from './type';

export default function MenuSettings({ actions }: { actions: IMenu[] }) {
  return (
    <>
      <div
        className="flex w-full flex-row gap-2 bg-linear-gradient"
        data-testid="menu-settings-container"
      >
        <div
          className="flex w-full flex-row items-center justify-center gap-2 p-2"
          data-testid="menu-settings-actions-container"
        >
          {actions.map((menu, i) => (
            <button
              key={`action-${i}`}
              data-testid={`menu-settings-action-${menu.key}`}
              type="button"
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                if (menu.action) {
                  if (menu.disabled) return;
                  menu.action(e);
                }
              }}
              disabled={menu.disabled}
              className={twMerge([
                'flex items-center justify-center gap-2',
                'rounded border border-blue-400 bg-white px-2 py-2 text-sm font-semibold capitalize text-gray-900 shadow-sm ring-1 ring-inset ring-blue-400 hover:border-white hover:bg-blue-400 hover:text-white hover:ring-0',
                menu.disabled ? 'cursor-not-allowed text-gray-400' : '',
              ])}
            >
              {menu.icon}
              {menu.title}
            </button>
          ))}
        </div>
      </div>
      <h1
        className="text-center text-2xl font-medium text-blue-400"
        data-testid="menu-settings-project-title"
      >
        PROJECT
      </h1>
    </>
  );
}
